import './App.css'
import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import Success from './Invite/components/Success'
import '@mantine/core/styles.css'
import QueryReport from './QueryReport'
import Report from './Report'
import Invite from './Invite'
import Orders from './Orders'
import Login from './Login'
import ErrorPage from './ErrorPage'
import Sample from './Sample'
import Payment from './Payment'
import UpgradeRule from './UpgradeRule'
import Faceid from './Faceid'
import PromotionReports from './PromotionReports'
import Complaint from './Complaint'
import Home from './Home'
import MerchantApply from './MerchantApply'
import MerchantApplyCallback from './MerchantApplyCallback'
import MerchantComplete from './MerchantComplete'
import MerchantCompleteCallback from './MerchantCompleteCallback'

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/queryReport" element={<QueryReport />} />
      <Route path="/promotionReports" element={<PromotionReports />} />
      <Route path="/reports/:orderId" element={<Report />} />
      <Route path="/reportSamples/:templateId" element={<Sample />} />
      <Route path="/success" element={<Success />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/login" element={<Login />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/upgradeRule" element={<UpgradeRule />} />
      <Route path="/faceid" element={<Faceid />} />
      <Route path="/complains" element={<Complaint />} />
      <Route path="/merchantApply" element={<MerchantApply />} />
      <Route path="/merchantApplyCallback" element={<MerchantApplyCallback />} />
      <Route path="/merchantComplete" element={<MerchantComplete />} />
      <Route path="/merchantCompleteCallback" element={<MerchantCompleteCallback />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  )
}

export default App
